// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"c60e470f","453":"6f762c60","905":"7edb3003"}[chunkId] + ".chunk.js";
};